import React from "react"
import { CaseStudyTemplate } from "./CaseStudyTemplate"

export default function ConceptsOfThoughtsCaseStudy() {
  return (
    <CaseStudyTemplate
      backToAnchorId="selected-work-concepts-of-thoughts"
      eyebrow="Selected work"
      tag="Brand Identity"
      title="Concepts of Thoughts — Premium Identity & Mockups"
      summary="A minimalist identity system built to feel refined, modern, and memorable—paired with high-end mockups that instantly elevate perception."
      image="/Logo%20on%20Card%20Mockup.png"
      imageAlt="Concepts of Thoughts logo on card mockup"
      sections={[
        {
          title: "The challenge",
          body: "Create a logo mark that reads premium at a glance—clean enough for modern design tastes, but distinct enough to be recognizable across materials.",
        },
        {
          title: "The solution",
          body: "A restrained, confident visual direction with a refined mark and typography pairing. The system is built to scale from social avatars to print, without losing clarity.",
        },
        {
          title: "Delivery",
          body: "A consistent brand kit plus mockups that show real-world use—helping the brand launch stronger with visuals that look established from day one.",
        },
      ]}
      tech={["Adobe Illustrator", "Adobe Photoshop", "Figma", "Brand Strategy"]}
      results={[
        "Premium-first direction",
        "Reusable identity kit",
        "Print & digital ready",
        "Launch-ready mockups",
      ]}
    />
  )
}

